import { Controller } from "stimulus"
import $ from 'jquery';
require('block-ui/jquery.blockUI')

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
};

export default class extends Controller {
    connect() {
        let locale = $('body').data('locale');
        sessionStorage.setItem('locale',locale);
        I18n.locale = locale;
    }

    updateSrc(e){
        e.preventDefault();
        let url = this.data.get('url');
        $('#gatewaymini').attr('src', url);
        jQuery.ajax({
            async: true,
            evalScripts: true,
            type: "POST",
            contentType: "application/x-www-form-urlencoded",
            url: this.data.get('mark_redsys_transaction_used'),
            data: {id: this.data.get('id')},
            success: function () {
                // jQuery.blockUI( {
                //     message: null,
                //     css: {
                //         border: 'none',
                //         padding: '15px',
                //         backgroundColor: '#000',
                //         '-webkit-border-radius': '10px',
                //         '-moz-border-radius': '10px',
                //         opacity: .5,
                //         color: '#fff'}
                // });
                // setTimeout(jQuery.unblockUI, 5000);
                jQuery('#confirm_form').css('display','none');
                jQuery('#request_data_ok_message').css('display','none');

                jQuery('#payment_type').css('display','block');
            },
            error: function () {
                // alert("Error");
            }
        });
    };

    updatePaymentForm(e){
        e.preventDefault();
        let url = this.data.get('url');
        $('#gatewaymini').attr('src', url);
        jQuery.ajax({
            async: true,
            evalScripts: true,
            type: "POST",
            contentType: "application/x-www-form-urlencoded",
            url: this.data.get('mark_redsys_transaction_used'),
            data: {id: this.data.get('id')},
            success: function () {
                jQuery('#confirm_form').css('display','none');
                jQuery('#request_data_ok_message').css('display','none');

                jQuery('#payment_form').css('display','block');
            },
            error: function () {
                // alert("Error");
            }
        });
    };

    next(e){
        let target = document.getElementById(e.target.dataset.target);
        let from = document.getElementById(e.target.dataset.from);
        let active = e.target.dataset.active || 'false';

        if(active === 'true'){
            let desactive = e.target.dataset.desactive;
            let desactive2 = e.target.dataset.desactive2;
            e.target.classList.add('active-jump');
            document.getElementById(desactive).classList.remove('active-jump');
            document.getElementById(desactive2).classList.remove('active-jump');
        }
        // active-jump
        from.style.display = 'none';
        target.style.display = 'block';
        sessionStorage.setItem('lets_validate',true);
    }

    validate(e){
        e.preventDefault();
        e.stopPropagation();
        let form = $(`#${e.target.dataset.form}`);
        let inputs = form.find('input.required');
        let count = 0;

        $.blockUI( {
            // title: 'Procesando... ',
            message: I18n.t('procesing_data'),
            // theme: true,
            css: {
                border: 'none',
                padding: '15px',
                backgroundColor: 'rgba(0,0,0,0)',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                color: '#ffffff'
            },
            overlayCSS:  {
                backgroundColor: 'rgba(0,0,0)',
                opacity:         0.8,
                cursor:          'wait'
            },
        });

        inputs.each((index, elem) => {
            let field = $(elem)[0];
            let parent = field.parentNode;
            let helper = $(parent).children('.helper-text')[0];

            if(field.value.isEmpty()){
                field.classList.add('alerta-invalid');
                helper.innerHTML = `<p>${I18n.t('field.required')}</p>`;
                count++;
            }else{
                field.classList.remove('alerta-invalid');
                helper.innerHTML = "";
            }
        })


        if(count === 0){
           $(`#${e.target.dataset.submit}`).trigger('click');
        }else{
            $.unblockUI()
        }

    }
}